import { useState, useEffect } from "react";
import Error from "../_error";

import { hasProperty } from "../../utils/validate";

import { addDataLayerEvent } from "../../utils/data.layer.utils/data.layer.util";
import { PageProps, RoadsyncPageProps } from "../../components/Pages/campaigns/roadsync/types";
import RoadsyncCampaignPageInner from "../../components/Pages/campaigns/roadsync";

import { GetServerSidePropsContext } from "next";
import { getCampaign } from "../../utils/page-requests/campaigns";

const slug = "roadsync";

const RoadsyncCampaignPage = (props: RoadsyncPageProps) => {
	const { data } = props;

	if (hasProperty(data, 'error')) {
		return <Error error={data.error} errorCode={data.error.code} />
	}

	if (!data) {
		return <Error error={"The page could not be found."} errorCode={404} />
	}

	return (
		<RoadsyncPageWithTracking data={data} />
	);
};

const RoadsyncPageWithTracking = ({ data }: PageProps) => {
	const [loaded, setLoaded] = useState(false);

	useEffect(() => {
		if (!loaded && typeof window !== undefined) {
			addDataLayerEvent('CampaignPageView', {
				title: data.title,
				url: data.url,
				type: data.type,
				category: "category" in data && data.category ? data.category : null,
				slug: "slug" in data && data.slug ? data.slug : null,
			});
			setLoaded(true);
			console.log("recorded page event");
		}
	}, [data, loaded]);

	return <RoadsyncCampaignPageInner data={data} />;
}

const failedResponseProps: PageProps = {
	data: undefined
};

type ServerPageProps = PageProps & {
	dehydratedState?: any
};

type SyncResponse = {
	props: ServerPageProps
};

const failedResponse: SyncResponse = {
	props: failedResponseProps,
};

export const getServerSideProps = (async ({ query, params, req, res }: GetServerSidePropsContext): Promise<SyncResponse> => {
	const { token } = query;

	const { data, status } = await getCampaign(slug as string, token as string);

	// to simplify page loading for now - too many bugs and rerenders with existing code on campaign pages
	try {
		if (status !== 200) {
			return failedResponse;
		}

		return {
			props: {
				data,
			}
		};
	} catch (e) {
		console.error("error getting campaign", e);
	}

	return failedResponse;
});

export default RoadsyncCampaignPage;